import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
export function CTAButton() {
  return <a href="https://mindinfonow.online/vsldrm-01/?src=advdrm2" className="bg-red-600 hover:bg-red-700 text-white font-bold py-3 px-6 rounded-md flex items-center justify-center w-full max-w-md mx-auto transition-colors duration-200" target="_blank" rel="noopener noreferrer" data-id="element-104">
      <span data-id="element-105">Click Here to Watch</span>
      <ArrowRightIcon className="ml-2 h-4 w-4" data-id="element-106" />
    </a>;
}